module.exports = __webpack_public_path__ + "static/ostrichsans-black-746a5a6ab1c912b5f8c7c4d2881a8a2c.ttf";